import { Styles } from "react-joyride";

// Tour styling to match app theme
export const tourStyles: Partial<Styles> = {
  options: {
    arrowColor: "#fff",
    backgroundColor: "#fff",
    overlayColor: "rgba(0, 0, 0, 0.5)",
    primaryColor: "#1737A2",
    textColor: "#333",
    width: 380,
    zIndex: 10000,
  },
  tooltip: {
    borderRadius: "8px",
    padding: "20px",
  },
  tooltipContainer: {
    textAlign: "left",
  },
  tooltipTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "10px",
  },
  tooltipContent: {
    fontSize: "14px",
    lineHeight: "1.6",
    padding: "10px 0",
  },
  buttonNext: {
    backgroundColor: "#1737A2",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: "500",
  },
  buttonBack: {
    color: "#666",
    marginRight: "10px",
    fontSize: "14px",
  },
  buttonSkip: {
    color: "#666",
    fontSize: "14px",
  },
  buttonClose: {
    color: "#666",
    fontSize: "14px",
  },
};

// Selector definitions for tour targets
export const TOUR_SELECTORS = {
  // Dashboard
  dashboardWelcome: '[data-tour="dashboard-welcome"]',
  
  // Header items
  headerMessages: '[data-tour="header-messages"]',
  headerCalendar: '[data-tour="header-calendar"]',
  
  // Sidebar items
  sidebarDashboard: '[data-tour="sidebar-dashboard"]',
  sidebarAgency: '[data-tour="sidebar-agency"]',
  sidebarClients: '[data-tour="sidebar-clients"]',
  sidebarProspects: '[data-tour="sidebar-prospects"]',
  sidebarQuoting: '[data-tour="sidebar-quoting"]',
  headerTasks: '[data-tour="header-tasks"]',
  sidebarMarketing: '[data-tour="sidebar-marketing"]',
  sidebarDirectory: '[data-tour="sidebar-directory"]',
  sidebarReports: '[data-tour="sidebar-reports"]',
  
  // Agency page tabs
  agencyTabProfile: '[data-tour="agency-tab-profile"]',
  agencyTabEmployees: '[data-tour="agency-tab-employees"]',
  agencyTabRoles: '[data-tour="agency-tab-roles"]',
  agencyTabTeams: '[data-tour="agency-tab-teams"]',
  agencyTabCommissions: '[data-tour="agency-tab-commissions"]',
  agencyTabBenefits: '[data-tour="agency-tab-benefits"]',
  agencyTabDocuments: '[data-tour="agency-tab-documents"]',
  agencyTabOrganization: '[data-tour="agency-tab-organization"]',
};

// Tour configuration
export const TOUR_CONFIG = {
  continuous: true,
  showProgress: true,
  showSkipButton: true,
  disableCloseOnEsc: false,
  disableOverlayClose: false,
  spotlightClicks: false,
  hideBackButton: false,
  locale: {
    back: "Back",
    close: "Close",
    last: "Finish",
    next: "Next",
    skip: "Skip Tour",
  },
};

// Employer tour selectors
export const EMPLOYER_TOUR_SELECTORS = {
  sidebarDashboard: '[data-tour="employer-sidebar-dashboard"]',
  sidebarCompany: '[data-tour="employer-sidebar-company"]',
  sidebarEmployees: '[data-tour="employer-sidebar-employees"]',
  sidebarBenefits: '[data-tour="employer-sidebar-benefits"]',
  sidebarTimeOff: '[data-tour="employer-sidebar-timeoff"]',
  sidebarDocuments: '[data-tour="employer-sidebar-documents"]',
  sidebarCompliance: '[data-tour="employer-sidebar-compliance"]',
};

// Local storage keys
export const TOUR_STORAGE_KEYS = {
  completed: (userId: string) => `broker_tour_completed_${userId}`,
  dismissed: (userId: string) => `broker_tour_dismissed_${userId}`,
};

export const EMPLOYER_TOUR_STORAGE_KEYS = {
  completed: (userId: string) => `employer_tour_completed_${userId}`,
  dismissed: (userId: string) => `employer_tour_dismissed_${userId}`,
};

